/**
 * The origin is split between two apps. The Indigo SPA owns `/login`,
 * `/signout` and `/select-branch`; this app owns everything else. That split is
 * invisible to react-router, which would happily "navigate" to one of those
 * paths and render nothing, so every hand-off has to be a real document load.
 */
export const LOGIN_PATH = "/login";
export const SELECT_BRANCH_PATH = "/select-branch";

/**
 * Hand the browser to the SPA's login page.
 *
 * @param {{ replace?: boolean }} [options] `replace` keeps the dead page out of
 *   the history, so Back does not bounce the user straight back into it.
 */
export const goToLogin = (options = {}) => {
  if (options.replace) {
    window.location.replace(LOGIN_PATH);
    return;
  }

  window.location.assign(LOGIN_PATH);
};

/**
 * Hand the browser to the SPA's branch picker.
 */
export const goToSelectBranch = () => {
  window.location.replace(SELECT_BRANCH_PATH);
};
